import { useContext, useEffect } from "react";
import ActionIcon from "../ui/action-icon";
import { ArrowLeft } from "lucide-react";
import SideBarContext from "../../contexts/side-bar-context";
import { useRouter } from "next/router";
import ProfileCard from "../ui/profile-card";
import NavMenuItem from "../ui/nav-menu-item";
import { prefix } from "../../lib/auth";
import SidebarToggle from "../ui/sidebar-toggle";

const SettingsDrawer = () => {
    const {
        isSideBarOpen,
        toggleSettings,
        isSettingsPage,
    } = useContext(SideBarContext);

    const router = useRouter();
    const isFeatureEnabled = router.query.enable === 'all'

    return (
    <div className="max-w-[240px] lg:min-w-[240px] lg:w-[250px] w-full border-l-[1px] custom-border-grey-50 h-full custom-bg-white-50 hidden lg:grid gap-[6px] content-start transition-all duration-300 transform absolute lg:relative lg:z-0 z-50">
            <div className="flex items-center justify-start gap-[12px] h-[69.3px] px-[26px] custom-bg-grey-50 ">
                {!isSideBarOpen && <SidebarToggle />}
                <span className="poppins-medium leading-[27px] text-[18px] custom-text-grey-900 truncate">Settings</span>
            </div>
            <div className='grid gap-[4px] conent-start w-full px-[10.5px] pt-[33px]'>
                <NavMenuItem href='/manage-people' icon='settings'>Manage Team</NavMenuItem>
                <NavMenuItem href={`http://${prefix()}accounts.workpeg.com`} newTab icon='user-round'>Manage Business</NavMenuItem>
            </div>
        </div>
    );
};

export default SettingsDrawer;